import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  orgUrl = localStorage.getItem('currentOrganisation');

  constructor(private afs: AngularFirestore) { }

  fetchNotifications() {
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.NotificationsCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        return data;
      })
    });
  }

  readAllNotification(noOfNotification) {
    this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.NotificationsCollection).doc('MarkedNotification').update({'MarkedNotifications':noOfNotification});
  }

}
